export default "__VITE_ASSET__180f6c73__"